module.exports = __webpack_public_path__ + "img/s1-300x179.849a8b46.jpg";